import React, { FormEvent, useState } from "react";
import moment, { min } from "moment";
import {
  Button,
  Form,
  Input,
  InputGroup,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";

interface IProps {
  hasTimeFilter?: boolean;
  onSubmit: (dates: { start_date: string; end_date: string }) => void;
  onCancel: () => void;
  minDate?: { start_date: string; end_date: string };
  maxDate?: { start_date: string; end_date: string };
  initialDate?: { start_date: string; end_date: string };
}

function DateRange({
  hasTimeFilter,
  onCancel,
  onSubmit,
  minDate,
  maxDate,
  initialDate,
}: IProps) {
  const [openModal, setOpenModal] = useState(false);
  const toggleOpenModal = () => setOpenModal(!openModal);
  const [selectedDate, setSelectedDate] = useState<{
    start_date: string;
    end_date: string;
  }>(initialDate);

  return (
    <React.Fragment>
      <Button color="secondary" size="sm" onClick={toggleOpenModal}>
        Select Date <i className="fas fa-calendar-week"></i>
      </Button>
      <Modal isOpen={openModal} toggle={toggleOpenModal} className={""}>
        <ModalHeader toggle={toggleOpenModal}>Select Date</ModalHeader>
        <ModalBody className="pt-0">
          <Form
            className="form"
            onSubmit={(e) => {
              e.preventDefault();
              onSubmit(selectedDate);
              toggleOpenModal();
            }}
          >
            <InputGroup>
              <Input
                id="start_date"
                name="date"
                placeholder="date placeholder"
                type={hasTimeFilter ? "datetime-local" : "date"}
                min={minDate ? minDate?.start_date : "2021-01-01"}
                max={
                  maxDate ? maxDate?.start_date : moment().format("YYYY-MM-DD")
                }
                value={selectedDate?.start_date}
                onChange={(e) => {
                  setSelectedDate((prev) => ({
                    ...prev,
                    start_date: e.target.value,
                  }));
                }}
              />
            </InputGroup>
            <InputGroup>
              <Input
                id="end_date"
                name="end_date"
                placeholder="date placeholder"
                type={hasTimeFilter ? "datetime-local" : "date"}
                className="mt-2"
                min={minDate ? minDate?.end_date : "2021-01-01"}
                max={
                  maxDate ? maxDate?.end_date : moment().format("YYYY-MM-DD")
                }
                value={selectedDate?.end_date}
                onChange={(e) => {
                  setSelectedDate((prev) => ({
                    ...prev,
                    end_date: e.target.value,
                  }));
                }}
              />
            </InputGroup>
            <div className="mt-2 d-flex justify-content-end">
              <Button
                color="secondary"
                onClick={() => {
                  onCancel();
                  toggleOpenModal();
                }}
                className="mr-2"
              >
                Clear
              </Button>

              <Button type="submit" color="primary" className="">
                Submit
              </Button>
            </div>
          </Form>
        </ModalBody>
        {/* <ModalFooter>
                        <Button color="secondary" onClick={toggleOpenModal}>Ok</Button>
                    </ModalFooter> */}
      </Modal>
    </React.Fragment>
  );
}

export default DateRange;
